import { useAppSelector } from '@@/auto/hooks/redux';
import { getIsLoggedIn } from '@@/auto/store/selectors';

export default function useIsLoggedIn() {
  return useAppSelector(getIsLoggedIn);
}
